import { render, staticRenderFns } from "./tarifarioForm.vue?vue&type=template&id=14cf537c&scoped=true"
import script from "./tarifarioForm.vue?vue&type=script&lang=js"
export * from "./tarifarioForm.vue?vue&type=script&lang=js"
import style0 from "./tarifarioForm.vue?vue&type=style&index=0&id=14cf537c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cf537c",
  null
  
)

export default component.exports